"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FooterSaveContractIdChange = void 0;
const i18n_1 = require("@app/util/i18n");
const _ui_1 = require("@ui");
const react_1 = __importDefault(require("react"));
const FooterSaveContractIdChange = ({ details, close, selectedContractId, updateLiveShift }) => {
    if (!details)
        return null;
    return (react_1.default.createElement("div", { className: 'ds-viewshift-row', style: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
        } },
        react_1.default.createElement(_ui_1.Text, { type: 'body-small' },
            "DS ID: ",
            details.id),
        react_1.default.createElement("div", { style: { display: 'flex' } },
            react_1.default.createElement(_ui_1.Button, { label: (0, i18n_1.t)('CLOSE'), onClick: () => close() }),
            react_1.default.createElement(_ui_1.Button, { style: _ui_1.Button.STYLES.CONTAINED, label: (0, i18n_1.t)('SAVE'), onClick: () => {
                    updateLiveShift(details.id, { contractId: selectedContractId })
                        .then(() => {
                        close();
                    })
                        .catch(() => { });
                } }))));
};
exports.FooterSaveContractIdChange = FooterSaveContractIdChange;
